module.exports = __webpack_public_path__ + "img/zippykind-2.20e8b0fb.jpg";